import React from 'react'
import Box from '@mui/material/Box'
import Fade from '@mui/material/Fade'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'

import AuthorizedHeader from '../../components/authorized-header'
import Translate from '../../components/translate'
import Notifications from '../../components/notifications'
import StyledContainer from '../../components/styled-container'
import * as Headline from '../../components/headline'

import SessionContext from '../../contexts/session'

import {
    reducer,
    initialState,
    StoreContext,
    creationRequested,
    dismissNotification,
} from './store'
import ListUsers from './list-users'
import AddUser from './add-user'
import ManageRoles from './manage-roles'
import EditUser from './edit-user'

const Users: React.FC = React.memo(function Users() {
    const [state, dispatch] = React.useReducer(reducer, initialState)
    const store = React.useMemo(() => ({ state, dispatch }), [state, dispatch])
    const session = React.useContext(SessionContext)

    const handleDismissNotifictaion = React.useCallback(
        (id: number) => dispatch(dismissNotification(id)),
        [dispatch]
    )

    return (
        <Box
            component='div'
            data-testid='users'
            sx={{
                backgroundColor: (theme) => theme.palette.background.default,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <AuthorizedHeader />
            <Fade in={true}>
                <StyledContainer maxWidth={false}>
                    <Headline.Component
                        title={<Translate>USERS</Translate>}
                        actionBar={
                            session.me.permissions.manage ? (
                                <Button
                                    variant='contained'
                                    startIcon={<AddIcon />}
                                    onClick={() =>
                                        dispatch(creationRequested())
                                    }
                                >
                                    <Translate>USER</Translate>
                                </Button>
                            ) : null
                        }
                    />
                    <StoreContext.Provider value={store}>
                        <ListUsers />
                        <AddUser />
                        <EditUser />
                        <ManageRoles />
                        <Notifications
                            notifications={state.notifications}
                            onDismissNotification={handleDismissNotifictaion}
                        />
                    </StoreContext.Provider>
                </StyledContainer>
            </Fade>
        </Box>
    )
})

export default Users
